<template>
  <div>
    <div class="crumbs">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item>
          <i class="el-icon-lx-calendar" /> 查询管理
        </el-breadcrumb-item>
        <el-breadcrumb-item>采集统计</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="container">
      <div class="handle-box">
        <el-form ref="searchform" :model="searchform" label-width="90px" @keyup.enter.native="search">
          <el-row>
            <el-col :span="6">
              <el-form-item label="工单" prop="orderno">
                <el-input v-model.trim="searchform.orderno" clearable placeholder="请输入工单" />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="批次" prop="batchno">
                <el-input v-model.trim="searchform.batchno" clearable placeholder="请输入批次" />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="产品" prop="productCode">
                <el-select
                  v-model="searchform.productCode"
                  clearable
                  filterable
                  remote
                  :remote-method="getproductlist"
                  :loading="productloading"
                  placeholder="请输入产品名称"
                  style="width:100%"
                >
                  <el-option
                    v-for="item in productlist"
                    :key="item.product_code"
                    :label="item.product"
                    :value="item.product_code"
                  />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="产线" prop="worklineCode">
                <el-select v-model="searchform.worklineCode" clearable filterable placeholder="请选择产线" style="width:100%">
                  <el-option
                    v-for="item in worklinelist"
                    :key="item.workline_code"
                    :label="item.workline_display"
                    :value="item.workline_code"
                  />
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="上传时间" prop="uploadTimeRange">
                <el-date-picker
                  v-model="searchform.uploadTimeRange"
                  type="datetimerange"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  range-separator="-"
                  start-placeholder="开始时间"
                  end-placeholder="结束时间"
                  style="width:100%"
                />
              </el-form-item>
            </el-col>
            <el-col :span="10" :offset="1">
              <el-button @click="resetForm('searchform')">重置</el-button>
              <el-button type="primary" icon="el-icon-search" @click="search">搜索</el-button>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <br>
      <el-row type="flex" class="row-bg">
        <el-col :span="24" class="border">
          <h4>采集统计</h4>
          <el-divider />
          <el-table
            id="parent"
            v-loading="listLoading"
            border
            :data="tableData"
            element-loading-text="拼命加载中"
            style="width:100%"
          >
            <el-table-column prop="orderno" label="工单" min-width="130" show-overflow-tooltip />
            <el-table-column prop="batchno" label="批次" min-width="130" show-overflow-tooltip />
            <el-table-column prop="productText" label="产品" min-width="220" show-overflow-tooltip />
            <el-table-column prop="worklineText" label="产线" min-width="180" show-overflow-tooltip />
            <el-table-column prop="planText" label="计划数量" min-width="110" show-overflow-tooltip />
            <!-- <el-table-column prop="collected_quantity" label="已采集数量" min-width="110" show-overflow-tooltip />
            <el-table-column prop="collectRateText" label="采集率" min-width="90" show-overflow-tooltip /> -->
            <el-table-column prop="machine_count" label="工控机数" min-width="90" show-overflow-tooltip />
            <el-table-column prop="alarm_count" label="报警数" min-width="80" show-overflow-tooltip />
            <el-table-column prop="uploadTimeText" label="上传时间" min-width="160" show-overflow-tooltip />
            <el-table-column prop="switchTimeText" label="换工单时间" min-width="160" show-overflow-tooltip />
            <el-table-column label="操作" width="90" fixed="right">
              <template slot-scope="scope">
                <el-button type="primary" size="mini" @click="showDetail(scope.row)">详情</el-button>
              </template>
            </el-table-column>
          </el-table>
          <br>
          <el-pagination
            background
            :current-page.sync="currentPage"
            :page-sizes="[10, 20, 30, 50]"
            layout="total,prev, pager, next,jumper,sizes"
            :total="total_count"
            @current-change="currentchange"
            @size-change="pagesize"
          />
        </el-col>
      </el-row>
    </div>

    <el-dialog title="采集详情" :visible.sync="detailVisible" width="70%">
      <el-table v-loading="detailLoading" border :data="detailMachines" style="width:100%">
        <el-table-column type="expand">
          <template slot-scope="scope">
            <div class="detail-block">
              <h4>相机信息</h4>
              <el-table border :data="scope.row.Cameras || []" size="mini">
                <el-table-column prop="CameraName" label="相机" min-width="140" show-overflow-tooltip />
                <el-table-column prop="CameraStatusText" label="状态" width="90" />
                <el-table-column prop="CollectCount" label="采集数" width="100" />
                <el-table-column prop="FailCount" label="失败数" width="100" />
                <el-table-column prop="CollectRateText" label="采集率" width="100" />
              </el-table>
              <h4>报警信息</h4>
              <el-table border :data="scope.row.Alarms || []" size="mini">
                <el-table-column prop="AlarmTime" label="报警时间" min-width="160" show-overflow-tooltip />
                <el-table-column prop="AlarmContent" label="报警内容" min-width="260" show-overflow-tooltip />
                <el-table-column prop="UploadTimeText" label="上传时间" min-width="160" show-overflow-tooltip />
              </el-table>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="MachineCode" label="工控机编码" min-width="140" show-overflow-tooltip />
        <el-table-column prop="MachineName" label="工控机名称" min-width="160" show-overflow-tooltip />
        <el-table-column prop="MachineStatusText" label="状态" width="90" />
        <el-table-column prop="AssociationLevelName" label="关联级别" min-width="120" show-overflow-tooltip />
        <el-table-column prop="ChildCollectCount" label="子级采集数" width="110" />
        <el-table-column prop="ParentCollectCount" label="父级采集数" width="110" />
        <el-table-column prop="AssociationRateText" label="关联率" width="100" />
        <el-table-column prop="AlarmCount" label="报警数" width="90" />
      </el-table>
    </el-dialog>
  </div>
</template>

<script>
import { scadaCollectStatDetail, scadaCollectStatList } from '@/api/query'
import { productlist } from '@/api/base'
import { worklinelist } from '@/api/plant'

export default {
  name: 'ScadaCollectStat',
  /**
   * 查询页把筛选、列表和详情弹窗状态放在同一处，避免分页和弹窗状态互相漂移。
   */
  data() {
    return {
      listLoading: false,
      productloading: false,
      tableData: [],
      productlist: [],
      worklinelist: [],
      detailVisible: false,
      detailLoading: false,
      detailMachines: [],
      total_count: 0,
      currentPage: 1,
      searchform: {
        orderno: null,
        batchno: null,
        productCode: null,
        worklineCode: null,
        uploadTimeRange: [],
        pageIndex: 1,
        pageSize: 10
      }
    }
  },
  /**
   * 页面进入后立即加载下拉基础数据和首屏列表，保持查询管理模块的一致使用节奏。
   */
  mounted() {
    this.getproductlist()
    this.getworklinelist()
    this.Tabledata()
  },
  methods: {
    /**
     * 产品下拉使用远程搜索，避免一次性加载全量产品拖慢查询页。
     */
    getproductlist(value) {
      if (value !== '') {
        this.productloading = true
        productlist({ productName: value }).then(response => {
          this.productloading = false
          this.productlist = response.data.data || []
          for (let i = 0; i < this.productlist.length; i++) {
            this.productlist[i].product = `${this.productlist[i].product_code}   ${this.productlist[i].product_name}`
          }
        }).catch(() => {
          this.productloading = false
        })
      } else {
        this.productlist = []
      }
    },
    /**
     * 产线下拉提前加载基础数据，避免查询时只能输入编码导致定位困难。
     */
    getworklinelist() {
      worklinelist({ pageSize: 1000 }).then(response => {
        const list = response.data.data || []
        // 产线下拉同时显示编码和名称，避免同名或近似名称产线难以区分。
        this.worklinelist = list.map(item => ({
          ...item,
          workline_display: `${item.workline_code || ''}|${item.workline_name || ''}`
        }))
      })
    },
    /**
     * 查询参数集中生成，避免列表刷新、分页和搜索使用不同的筛选口径。
     */
    buildParams() {
      const range = this.searchform.uploadTimeRange || []
      return {
        orderno: this.searchform.orderno,
        batchno: this.searchform.batchno,
        productCode: this.searchform.productCode,
        worklineCode: this.searchform.worklineCode,
        uploadStartTime: range[0] || null,
        uploadEndTime: range[1] || null,
        pageIndex: this.searchform.pageIndex,
        pageSize: this.searchform.pageSize
      }
    },
    /**
     * 列表只读取后端分页快照，避免前端本地筛选大量换工单历史。
     */
    Tabledata() {
      this.listLoading = true
      scadaCollectStatList(this.buildParams()).then(response => {
        const page = response.data || {}
        this.tableData = this.packdate(page.data || [])
        this.currentPage = page.page_index || 1
        this.total_count = page.total_count || 0
        this.listLoading = false
      }).catch(() => {
        this.listLoading = false
      })
    },
    /**
     * 展示字段统一整理，避免模板里散落空值处理和时间格式化规则。
     */
    packdate(list) {
      return list.map(item => ({
        ...item,
        productText: `${item.product_code || ''} ${item.product_name || ''}`,
        worklineText: `${item.workline_code || ''} ${item.workline_name || ''}`,
        planText: `${item.plan_quantity || 0}${item.plan_unit_name || item.plan_unit || ''}`,
        collectRateText: `${item.collect_rate || 0}%`,
        uploadTimeText: this.$parseTime(item.upload_time),
        switchTimeText: this.$parseTime(item.switch_time)
      }))
    },
    /**
     * 新筛选条件从第一页开始查，避免沿用上一页页码导致误以为没有数据。
     */
    search() {
      this.searchform.pageIndex = 1
      this.Tabledata()
    },
    /**
     * 重置后立即刷新列表，避免表单状态和表格内容不一致。
     */
    resetForm(formName) {
      this.$refs[formName].resetFields()
      this.searchform.pageIndex = 1
      this.Tabledata()
    },
    /**
     * 分页切换复用同一查询入口，避免页码变化绕过当前筛选条件。
     */
    currentchange(pageIndex) {
      this.searchform.pageIndex = pageIndex
      this.Tabledata()
    },
    /**
     * 每页条数变化后回到搜索入口，避免页容量变化后继续停留在无效页码。
     */
    pagesize(pageSize) {
      this.searchform.pageSize = pageSize
      this.search()
    },
    /**
     * 详情按快照主键即时拉取，避免列表接口携带设备明细造成首屏过重。
     */
    showDetail(row) {
      this.detailVisible = true
      this.detailLoading = true
      this.detailMachines = []
      scadaCollectStatDetail(row.id).then(response => {
        this.detailMachines = this.buildDetailMachines(response.data || {})
        this.detailLoading = false
      }).catch(() => {
        this.detailLoading = false
      })
    },
    /**
     * 详情接口按子表返回，前端需要恢复工控机与相机、报警之间的展示关系。
     */
    buildDetailMachines(detail) {
      const machines = detail.machines || detail.Machines || []
      const cameras = detail.cameras || detail.Cameras || []
      const alarms = detail.alarms || detail.Alarms || []
      // 后端保留结构化子表，前端在展示层恢复嵌套关系以便查看单台设备明细。
      return machines.map(machine => {
        const machineId = machine.id || machine.Id
        const machineCode = machine.machine_code || machine.MachineCode
        return {
          MachineCode: machineCode,
          MachineName: machine.machine_name || machine.MachineName,
          MachineStatusText: this.machineStatusText(machine.machine_status || machine.MachineStatus),
          AssociationLevelName: machine.association_level_name || machine.AssociationLevelName,
          ChildCollectCount: machine.child_collect_count || machine.ChildCollectCount || 0,
          ParentCollectCount: machine.parent_collect_count || machine.ParentCollectCount || 0,
          AssociationRateText: `${machine.association_rate || machine.AssociationRate || 0}%`,
          AlarmCount: machine.alarm_count || machine.AlarmCount || 0,
          Cameras: cameras
            .filter(camera => (camera.machine_id || camera.MachineId) === machineId ||
              (camera.machine_code || camera.MachineCode) === machineCode)
            .map(camera => ({
              CameraName: camera.camera_name || camera.CameraName,
              CameraStatusText: this.cameraStatusText(camera.camera_status || camera.CameraStatus),
              CollectCount: camera.collect_count || camera.CollectCount || 0,
              FailCount: camera.fail_count || camera.FailCount || 0,
              CollectRateText: `${camera.collect_rate || camera.CollectRate || 0}%`
            })),
          Alarms: alarms
            .filter(alarm => (alarm.machine_id || alarm.MachineId) === machineId ||
              (alarm.machine_code || alarm.MachineCode) === machineCode)
            .map(alarm => ({
              AlarmTime: alarm.alarm_time || alarm.AlarmTime,
              AlarmContent: alarm.alarm_content || alarm.AlarmContent,
              UploadTimeText: this.$parseTime(alarm.upload_time || alarm.UploadTime)
            }))
        }
      })
    },
    /**
     * 状态码保持接口原始枚举，统一在展示层转文案便于列表和详情复用。
     */
    machineStatusText(status) {
      const map = { '1': '运行', '2': '停止', '3': '未启动' }
      return map[status] || status || ''
    },
    /**
     * 相机状态码统一在展示层转文案，避免表格列重复维护枚举含义。
     */
    cameraStatusText(status) {
      const map = { '1': '在线', '2': '离线' }
      return map[status] || status || ''
    }
  }
}
</script>

<style scoped>
.el-divider--horizontal {
  display: block;
  height: 1px;
  width: 100%;
  margin: 10px 0;
}

.border {
  padding: 10px 10px;
  border-radius: 3px;
  border: 1px solid #e6ebf5;
  background-color: #fff;
  overflow: hidden;
  color: #303133;
  -webkit-transition: 0.3s;
  transition: 0.3s;
}

.handle-box {
  margin-bottom: 0;
}

.detail-block {
  padding: 0 24px 12px;
}

#parent {
  text-align: center;
}
</style>
